var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalustrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_56)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7196 54.7332H61.8712V42.8151C61.8712 36.2882 56.7374 30.9971 50.4045 30.9971C44.0716 30.9971 38.9378 36.2882 38.9378 42.8151V54.7332H34.0894V42.8151C34.0894 33.5283 41.3939 26 50.4045 26C59.415 26 66.7197 33.5284 66.7197 42.8151L66.7196 54.7332ZM66.5985 47.6874H36.5135V42.6903H66.5985L66.5985 47.6874ZM52.8287 54.7332H47.9803V28.4985H52.8287V54.7332Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_56)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 50.8525,
    width: 52.6875,
    height: 22.8644,
    rx: 3,
    fill: "url(#paint1_linear_1062_56)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 50.8525,
    width: 52.6875,
    height: 22.8644,
    rx: 3,
    stroke: "url(#paint2_linear_1062_56)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_56",
    x: 21.85,
    y: 48.7025,
    width: 56.9875,
    height: 27.1643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_56"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_56",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_56",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_56",
    x1: 29.6381,
    y1: 52.9621,
    x2: 59.3935,
    y2: 88.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_56",
    x1: 54.7344,
    y1: 54.6633,
    x2: 58.9914,
    y2: 77.5525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalustrades);
export default __webpack_public_path__ + "static/media/balustrades.af538629ed2207e2cd9baba9b456f0fb.svg";
export { ForwardRef as ReactComponent };